import { AssetTypeId, SystemTypeId } from '@Types/assetSchema.types';
import { useAssetSchema } from '../../hooks/assetSchemaHooks';

interface UseAssetTypeHasLengthArgs {
	systemType?: SystemTypeId;
	assetType?: AssetTypeId;
}

/**
 * Hook to determine if an asset type has a length property based purely on the asset schema
 * Uses getFlatProperties() to check for a property with id 'length'
 * Returns false while the schema is loading or if it fails to load
 * @param systemType - The system type ID
 * @param assetType - The asset type ID
 * @returns boolean indicating if the asset type has a length property according to the schema
 */
export function useAssetTypeHasLength({
	systemType,
	assetType,
}: UseAssetTypeHasLengthArgs): boolean {
	const { data: schema } = useAssetSchema(
		systemType?.id ?? '',
		assetType?.id ?? '',
	);

	// If we don't have the required parameters or schema, return false
	if (!systemType || !assetType || !schema) {
		return false;
	}

	const hasLengthProperty = !!schema.getFlatProperty('length');

	return hasLengthProperty;
}
